export const productDetails = {
  'genshin-impact': {
    id: 'genshin-impact',
    name: '原神',
    subtitle: '【UID自動儲值】',
    category: 'UID自動儲值',
    badge: 'UID自動',
    description: '此賣場為UID自動儲值，角色無需下線，下單付款3秒入帳。請填寫正確UID並且確認伺服器是否相符。下單前，再三確認UID及伺服器是否正確。若UID跟伺服器有誤，導致商品儲值至錯誤的角色，買家自行負責，本網站一概不負責。',
    warning: '因遊戲官方更改UID機制，部分帳號會遇到官方鎖區的問題，導致無法使用UID儲值。1.如您帳號被判定鎖區。2.創世結晶、事象凝核、空月祝福，商品內購價格，請聯繫客服（聯絡方式：ID：@laigame91 (@也要輸入)）。',
    servers: ['亞服', '台港澳服', '美服', '歐服'],
    isInternational: false,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '創世結晶、事象凝核、空月祝福等遊戲內貨幣，可用於抽取角色、武器及購買各種道具',
    planGroups: [
      {
        groupName: '創世結晶',
        icon: 'ri-gem-line',
        plans: [
          { id: 1, amount: '60枚創世結晶', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
          { id: 2, amount: '300枚創世結晶', price: 'NT$ 140', originalPrice: 'NT$ 165', discount: '85折', badge: '熱門' },
          { id: 3, amount: '980枚創世結晶', price: 'NT$ 390', originalPrice: 'NT$ 460', discount: '85折' },
          { id: 4, amount: '1980枚創世結晶', price: 'NT$ 790', originalPrice: 'NT$ 930', discount: '85折', badge: '推薦' },
          { id: 5, amount: '3280枚創世結晶', price: 'NT$ 1,220', originalPrice: 'NT$ 1,440', discount: '85折' },
          { id: 6, amount: '6480枚創世結晶', price: 'NT$ 2,310', originalPrice: 'NT$ 2,720', discount: '85折', badge: '最划算' },
          { id: 7, amount: '創世結晶一條龍', price: 'NT$ 4,880', originalPrice: 'NT$ 5,750', discount: '85折', badge: '超值' },
        ]
      },
      {
        groupName: '事象凝核',
        icon: 'ri-focus-3-line',
        plans: [
          { id: 8, amount: '60枚事象凝核', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
          { id: 9, amount: '300枚事象凝核', price: 'NT$ 140', originalPrice: 'NT$ 165', discount: '85折', badge: '熱門' },
          { id: 10, amount: '980枚事象凝核', price: 'NT$ 410', originalPrice: 'NT$ 480', discount: '85折' },
          { id: 11, amount: '1980枚事象凝核', price: 'NT$ 810', originalPrice: 'NT$ 955', discount: '85折', badge: '推薦' },
          { id: 12, amount: '3280枚事象凝核', price: 'NT$ 1,300', originalPrice: 'NT$ 1,530', discount: '85折' },
          { id: 13, amount: '6480枚事象凝核', price: 'NT$ 2,600', originalPrice: 'NT$ 3,060', discount: '85折', badge: '最划算' },
        ]
      },
      {
        groupName: '空月祝福',
        icon: 'ri-moon-line',
        plans: [
          { id: 14, amount: '空月祝福（月卡）', price: 'NT$ 140', originalPrice: 'NT$ 165', discount: '85折', badge: '每日領取' },
        ]
      }
    ],
    plans: [
      { id: 1, amount: '60枚創世結晶', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300枚創世結晶', price: 'NT$ 140', originalPrice: 'NT$ 165', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980枚創世結晶', price: 'NT$ 390', originalPrice: 'NT$ 460', discount: '85折' },
      { id: 4, amount: '1980枚創世結晶', price: 'NT$ 790', originalPrice: 'NT$ 930', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280枚創世結晶', price: 'NT$ 1,220', originalPrice: 'NT$ 1,440', discount: '85折' },
      { id: 6, amount: '6480枚創世結晶', price: 'NT$ 2,310', originalPrice: 'NT$ 2,720', discount: '85折', badge: '最划算' },
      { id: 7, amount: '創世結晶一條龍', price: 'NT$ 4,880', originalPrice: 'NT$ 5,750', discount: '85折', badge: '超值' },
      { id: 8, amount: '60枚事象凝核', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 9, amount: '300枚事象凝核', price: 'NT$ 140', originalPrice: 'NT$ 165', discount: '85折', badge: '熱門' },
      { id: 10, amount: '980枚事象凝核', price: 'NT$ 410', originalPrice: 'NT$ 480', discount: '85折' },
      { id: 11, amount: '1980枚事象凝核', price: 'NT$ 810', originalPrice: 'NT$ 955', discount: '85折', badge: '推薦' },
      { id: 12, amount: '3280枚事象凝核', price: 'NT$ 1,300', originalPrice: 'NT$ 1,530', discount: '85折' },
      { id: 13, amount: '6480枚事象凝核', price: 'NT$ 2,600', originalPrice: 'NT$ 3,060', discount: '85折', badge: '最划算' },
      { id: 14, amount: '空月祝福（月卡）', price: 'NT$ 140', originalPrice: 'NT$ 165', discount: '85折', badge: '每日領取' },
    ],
    reviews: [
      { id: 1, user: '玩家***123', rating: 5, comment: '非常快速，付款後3秒就到賬了！客服態度也很好', date: '2025-07-10', avatar: '🎮' },
      { id: 2, user: '遊戲***愛好者', rating: 5, comment: '價格實惠，比官方便宜很多，已經第五次購買了', date: '2025-07-09', avatar: '⭐' },
      { id: 3, user: '原神***旅行者', rating: 5, comment: 'UID自動儲值超方便，角色不用下線直接到賬，推薦！', date: '2025-07-08', avatar: '🌟' },
      { id: 4, user: '米***粉', rating: 5, comment: '創世結晶到賬超快，下次還會再來', date: '2025-07-07', avatar: '💎' },
      { id: 5, user: '提瓦特***冒險者', rating: 4, comment: '事象凝核也有賣，很方便，就是有時候客服回覆慢一點', date: '2025-07-06', avatar: '🗺️' },
      { id: 6, user: '空月***訂閱者', rating: 5, comment: '月卡空月祝福價格很划算，每天都能領創世結晶', date: '2025-07-05', avatar: '🌙' },
    ],
    faqs: [
      { question: '如何查詢我的UID？', answer: '進入原神遊戲後，點擊左上角的頭像，即可看到您的UID號碼。UID是一串9位數字，請確認伺服器與UID相符再下單。' },
      { question: 'UID自動儲值多久可以到賬？', answer: '此賣場為UID自動儲值，下單付款後約3秒即可入帳，角色無需下線，非常方便快速。' },
      { question: '創世結晶與事象凝核有什麼差別？', answer: '創世結晶是原神國際服（含台港澳服）使用的貨幣；事象凝核是原神國服（大陸服）使用的貨幣。請依您的帳號區服選擇正確品項。' },
      { question: '空月祝福（月卡）是什麼？', answer: '空月祝福購買後，每天可以在遊戲中領取60枚創世結晶，持續30天，共可領取1800枚創世結晶，非常划算。' },
      { question: '如果帳號被鎖區怎麼辦？', answer: '因遊戲官方更改UID機制，部分帳號可能遇到鎖區問題。如您帳號被判定鎖區，請聯繫客服LINE ID：@laigame91（@也要輸入）處理。' },
      { question: '填錯UID或伺服器可以退款嗎？', answer: '虛擬商品一經充值成功後無法退款。請下單前再三確認UID及伺服器是否正確，若因填寫錯誤導致儲值至錯誤角色，買家需自行負責。' },
      { question: '儲值安全嗎？', answer: '我們使用官方充值管道，100%安全可靠，已為超過10萬名玩家提供服務，24小時全年無休。' },
    ]
  },
  'honkai-star-rail': {
    id: 'honkai-star-rail',
    name: '崩壞：星穹鐵道',
    category: '角色扮演',
    description: '《崩壞：星穹鐵道》是米哈遊製作的全新銀河冒險策略遊戲。搭乘星穹列車，跟隨「開拓」的軌跡前行，在無盡的幻想世界中冒險。',
    isInternational: true,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '星瓊，可用於抽取角色、光錐及購買各種遊戲道具',
    plans: [
      { id: 1, amount: '60星瓊', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300+30星瓊', price: 'NT$ 150', originalPrice: 'NT$ 180', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110星瓊', price: 'NT$ 465', originalPrice: 'NT$ 550', discount: '85折' },
      { id: 4, amount: '1980+260星瓊', price: 'NT$ 930', originalPrice: 'NT$ 1100', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600星瓊', price: 'NT$ 1550', originalPrice: 'NT$ 1830', discount: '85折' },
      { id: 6, amount: '6480+1600星瓊', price: 'NT$ 3050', originalPrice: 'NT$ 3600', discount: '85折', badge: '最划算' }
    ],
    reviews: [
      { id: 1, user: '星穹***旅人', rating: 5, comment: '充值速度超快，價格也很優惠！', date: '2024-01-15', avatar: '🚂' },
      { id: 2, user: '開拓***者', rating: 5, comment: '已經充值多次了，非常穩定可靠', date: '2024-01-14', avatar: '⭐' },
      { id: 3, user: '米遊社***用戶', rating: 5, comment: '客服很專業，解答很詳細', date: '2024-01-13', avatar: '💫' }
    ],
    faqs: [
      { question: '如何查詢我的UID？', answer: '進入遊戲後，點擊左上角的頭像，即可看到您的UID號碼。' },
      { question: '充值後多久到賬？', answer: '通常5-30分鐘內到賬，請耐心等待。' },
      { question: '充值有風險嗎？', answer: '我們使用官方充值管道，完全安全可靠。' }
    ]
  },
  'zenless-zone-zero': {
    id: 'zenless-zone-zero',
    name: '絕區零',
    category: '動作遊戲',
    description: '《絕區零》是米哈遊開發的全新都市幻想動作遊戲。在近未來的新艾利都市，與形形色色的夥伴一起踏上冒險之旅。',
    isInternational: true,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '菲林，可用於抽取代理人、音擎及購買各種遊戲道具',
    plans: [
      { id: 1, amount: '60菲林', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300+30菲林', price: 'NT$ 150', originalPrice: 'NT$ 180', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110菲林', price: 'NT$ 465', originalPrice: 'NT$ 550', discount: '85折' },
      { id: 4, amount: '1980+260菲林', price: 'NT$ 930', originalPrice: 'NT$ 1100', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600菲林', price: 'NT$ 1550', originalPrice: 'NT$ 1830', discount: '85折' },
      { id: 6, amount: '6480+1600菲林', price: 'NT$ 3050', originalPrice: 'NT$ 3600', discount: '85折', badge: '最划算' }
    ],
    reviews: [
      { id: 1, user: '繩匠***玩家', rating: 5, comment: '新遊戲充值很方便，推薦！', date: '2024-01-15', avatar: '🎬' },
      { id: 2, user: '零號***特工', rating: 5, comment: '價格便宜，到賬快速', date: '2024-01-14', avatar: '⚡' }
    ],
    faqs: [
      { question: '如何查詢UID？', answer: '遊戲內點擊左上角頭像即可查看UID。' },
      { question: '充值安全嗎？', answer: '使用官方管道，100%安全。' }
    ]
  },
  'wuthering-waves': {
    id: 'wuthering-waves',
    name: '鳴潮',
    category: '角色扮演',
    description: '《鳴潮》是庫洛遊戲開發的開放世界動作遊戲。在充滿未知的世界中，與各具特色的共鳴者並肩作戰。',
    isInternational: false,
    originalTWD: 33,
    discountRate: 85,
    purchaseItem: '潮汐，可用於抽取共鳴者、武器及購買各種遊戲道具',
    plans: [
      { id: 1, amount: '60潮汐', price: 'NT$ 28', originalPrice: 'NT$ 33', discount: '85折' },
      { id: 2, amount: '300+30潮汐', price: 'NT$ 138', originalPrice: 'NT$ 165', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110潮汐', price: 'NT$ 450', originalPrice: 'NT$ 530', discount: '85折' },
      { id: 4, amount: '1980+260潮汐', price: 'NT$ 900', originalPrice: 'NT$ 1060', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600潮汐', price: 'NT$ 1500', originalPrice: 'NT$ 1770', discount: '85折' },
      { id: 6, amount: '6480+1600潮汐', price: 'NT$ 2950', originalPrice: 'NT$ 3480', discount: '85折', badge: '最划算' }
    ],
    reviews: [
      { id: 1, user: '漂泊***者', rating: 5, comment: '充值很快，客服態度好', date: '2024-01-15', avatar: '🌊' },
      { id: 2, user: '共鳴***玩家', rating: 5, comment: '價格實惠，值得信賴', date: '2024-01-14', avatar: '⚔️' }
    ],
    faqs: [
      { question: 'UID在哪裡查看？', answer: '遊戲設置中可以查看您的UID。' },
      { question: '多久到賬？', answer: '一般5-30分鐘內到賬。' }
    ]
  },
  'identity-v': {
    id: 'identity-v',
    name: '第五人格',
    category: '非對稱競技',
    description: '《第五人格》是網易開發的非對稱對抗競技遊戲。在哥德式的恐怖風格中，體驗緊張刺激的追逐與逃脫。',
    isInternational: false,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '回聲，可用於購買角色、時裝及各種遊戲道具',
    plans: [
      { id: 1, amount: '60回聲', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300+30回聲', price: 'NT$ 150', originalPrice: 'NT$ 180', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110回聲', price: 'NT$ 465', originalPrice: 'NT$ 550', discount: '85折' },
      { id: 4, amount: '1980+260回聲', price: 'NT$ 930', originalPrice: 'NT$ 1100', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600回聲', price: 'NT$ 1550', originalPrice: 'NT$ 1830', discount: '85折' }
    ],
    reviews: [
      { id: 1, user: '求生***玩家', rating: 5, comment: '充值快速，價格優惠', date: '2024-01-15', avatar: '🎭' },
      { id: 2, user: '監管***者', rating: 5, comment: '已經充值很多次了，很穩定', date: '2024-01-14', avatar: '🔦' }
    ],
    faqs: [
      { question: '如何充值？', answer: '選擇方案後填寫UID即可完成充值。' },
      { question: '安全嗎？', answer: '使用官方管道，完全安全。' }
    ]
  },
  'honor-of-kings': {
    id: 'honor-of-kings',
    name: '王者榮耀',
    category: 'MOBA',
    description: '《王者榮耀》是騰訊天美工作室開發的MOBA手遊。5V5公平對戰，百位英雄任你選擇，開啟你的榮耀之路。',
    isInternational: false,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '點券，可用於購買英雄、皮膚及各種遊戲道具',
    plans: [
      { id: 1, amount: '60點券', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300+30點券', price: 'NT$ 150', originalPrice: 'NT$ 180', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110點券', price: 'NT$ 465', originalPrice: 'NT$ 550', discount: '85折' },
      { id: 4, amount: '1980+260點券', price: 'NT$ 930', originalPrice: 'NT$ 1100', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600點券', price: 'NT$ 1550', originalPrice: 'NT$ 1830', discount: '85折' },
      { id: 6, amount: '6480+1600點券', price: 'NT$ 3050', originalPrice: 'NT$ 3600', discount: '85折', badge: '最划算' }
    ],
    reviews: [
      { id: 1, user: '王者***玩家', rating: 5, comment: '充值速度很快，價格也便宜', date: '2024-01-15', avatar: '👑' },
      { id: 2, user: '峽谷***之巔', rating: 5, comment: '老客戶了，一直很穩定', date: '2024-01-14', avatar: '⚔️' },
      { id: 3, user: '榮耀***戰士', rating: 5, comment: '客服很專業，推薦！', date: '2024-01-13', avatar: '🏆' }
    ],
    faqs: [
      { question: '如何查詢角色ID？', answer: '進入遊戲個人資料頁面即可查看角色ID。' },
      { question: '充值後多久到賬？', answer: '通常5-30分鐘內到賬。' },
      { question: '可以充值到其他區服嗎？', answer: '請確認您的區服後再下單，跨區無法充值。' }
    ]
  },
  'arknights': {
    id: 'arknights',
    name: '明日方舟',
    category: '策略塔防',
    description: '《明日方舟》是鷹角網絡開發的策略塔防遊戲。在末世廢土中，指揮幹員們對抗感染者危機。',
    isInternational: false,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '合成玉，可用於抽取幹員及購買各種遊戲道具',
    plans: [
      { id: 1, amount: '60合成玉', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300+30合成玉', price: 'NT$ 150', originalPrice: 'NT$ 180', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110合成玉', price: 'NT$ 465', originalPrice: 'NT$ 550', discount: '85折' },
      { id: 4, amount: '1980+260合成玉', price: 'NT$ 930', originalPrice: 'NT$ 1100', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600合成玉', price: 'NT$ 1550', originalPrice: 'NT$ 1830', discount: '85折' },
      { id: 6, amount: '6480+1600合成玉', price: 'NT$ 3050', originalPrice: 'NT$ 3600', discount: '85折', badge: '最划算' }
    ],
    reviews: [
      { id: 1, user: '博士***001', rating: 5, comment: '充值快速，價格實惠', date: '2024-01-15', avatar: '🏥' },
      { id: 2, user: '羅德島***幹員', rating: 5, comment: '已經充值多次，非常可靠', date: '2024-01-14', avatar: '⚕️' }
    ],
    faqs: [
      { question: 'UID在哪裡？', answer: '遊戲主界面右下角可以查看UID。' },
      { question: '充值安全嗎？', answer: '使用官方管道，100%安全。' }
    ]
  },
  'nikke': {
    id: 'nikke',
    name: '勝利女神：妮姬',
    category: '射擊RPG',
    description: '《勝利女神：妮姬》是由SHIFT UP開發的科幻射擊RPG遊戲。與美少女機器人並肩作戰，奪回被侵佔的地面。',
    isInternational: true,
    originalTWD: 35,
    discountRate: 85,
    purchaseItem: '寶石，可用於抽取角色、武器及購買各種遊戲道具',
    plans: [
      { id: 1, amount: '60寶石', price: 'NT$ 30', originalPrice: 'NT$ 35', discount: '85折' },
      { id: 2, amount: '300+30寶石', price: 'NT$ 150', originalPrice: 'NT$ 180', discount: '85折', badge: '熱門' },
      { id: 3, amount: '980+110寶石', price: 'NT$ 465', originalPrice: 'NT$ 550', discount: '85折' },
      { id: 4, amount: '1980+260寶石', price: 'NT$ 930', originalPrice: 'NT$ 1100', discount: '85折', badge: '推薦' },
      { id: 5, amount: '3280+600寶石', price: 'NT$ 1550', originalPrice: 'NT$ 1830', discount: '85折' },
      { id: 6, amount: '6480+1600寶石', price: 'NT$ 3050', originalPrice: 'NT$ 3600', discount: '85折', badge: '最划算' }
    ],
    reviews: [
      { id: 1, user: '指揮官***666', rating: 5, comment: '充值速度快，客服態度好', date: '2024-01-15', avatar: '💎' },
      { id: 2, user: 'NIKKE***玩家', rating: 5, comment: '價格優惠，值得推薦', date: '2024-01-14', avatar: '🎯' }
    ],
    faqs: [
      { question: '如何查看UID？', answer: '遊戲設置中可以查看您的UID。' },
      { question: '多久到賬？', answer: '一般5-30分鐘內到賬。' }
    ]
  }
};